import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormButtonComponent } from '../components/form-button/form-button.component';
import { MaterialIoModule } from './material-io.module';
import { ToastrModule } from 'ngx-toastr';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { PrimeNgModule } from './prime-ng.module';
import { AnimatedCounterComponent } from '../components/animated-counter/animated-counter.component';
import { ModuleContainerComponent } from '../components/module-container/module-container.component';
import { PrimengMultiselectComponent } from '../components/primeng-multiselect/primeng-multiselect.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialIoModule,
    PrimeNgModule,
    ReactiveFormsModule,

    ToastrModule.forRoot( {
      positionClass: 'toast-bottom-left',
      progressBar: true,
      progressAnimation:	'decreasing'
    }),

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    FormButtonComponent,
    AnimatedCounterComponent,
    ModuleContainerComponent,
    PrimengMultiselectComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    FormButtonComponent,
    ReactiveFormsModule,
    ToastrModule,
    AnimatedCounterComponent,
    TranslateModule,
    ModuleContainerComponent,
    PrimengMultiselectComponent,
    PrimeNgModule  // This exports all PrimeNG modules including AutoComplete
  ]
})
export class ABCisSharedModule { }
